import Accordion from 'react-bootstrap/Accordion';
import { Trans, useTranslation } from 'react-i18next';

const SectionFunctionalities = () => {
  const { t } = useTranslation();

  // const handleClick = () => {
  //   const el = document.getElementById('pricing-btn');
  //   el.firstChild.click();
  // };

  return (
    <section id='functionalitati' className='section-area'>
      <div className='container'>
        <div className='text-center'>
          <h3 className='heading'>
            <Trans i18nKey='section3.title'>
              Acces gratuit <span>la funcționalități cheie</span>
            </Trans>
          </h3>
        </div>
        <div className='align-items-start pt-5'>
          <Accordion className='row text-start'>
            <div className='col-lg-6'>
              <Accordion.Item
                className='shadow mb-4 p-2 border-0 wow fadeInLeftBig'
                eventKey='0'
              >
                <Accordion.Header>
                  <span>
                    <i className='fa-solid fa-user-gear'></i>
                    {t('section3.b1')}
                  </span>
                  <br />
                  {t('section3.b1Description')}
                </Accordion.Header>
              </Accordion.Item>
              <Accordion.Item
                className='shadow mb-4 p-2 border-0  wow fadeInLeftBig'
                eventKey='1'
              >
                <Accordion.Header>
                  <span>
                    <i className='fa-solid fa-chart-pie'></i>
                    {t('section3.b3')}
                  </span>
                  <br /> {t('section3.b3Description')}
                </Accordion.Header>
              </Accordion.Item>
            </div>
            <div className='col-lg-6'>
              <Accordion.Item
                className='shadow mb-4 p-2 border-0 wow fadeInRightBig'
                eventKey='4'
              >
                <Accordion.Header>
                  <span>
                    <i className='fa-solid fa-table-list'></i>
                    {t('section3.b4')}
                  </span>
                  <br />
                  {t('section3.b4Description')}
                </Accordion.Header>
              </Accordion.Item>
              <Accordion.Item
                className='shadow mb-4 p-2 border-0  wow fadeInLeftBig'
                eventKey='2'
              >
                <Accordion.Header>
                  <span>
                    <i className='fa-solid fa-file'></i>
                    {t('section3.b5')}
                  </span>
                  <br />
                  {t('section3.b5Description')}
                </Accordion.Header>
              </Accordion.Item>
            </div>
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default SectionFunctionalities;
